var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 78,
    viewBox: "0 0 40 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_side",
    transform: "translate(-1178 -162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14546",
    "data-name": "Rectangle 14546",
    width: 40,
    height: 78,
    rx: 12,
    transform: "translate(1178 162)",
    fill: "#f5f5f7",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_black_24dp",
    transform: "translate(1186 189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56157",
    "data-name": "Path 56157",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56158",
    "data-name": "Path 56158",
    d: "M5,13H16.17l-4.88,4.88a1.008,1.008,0,0,0,0,1.42,1,1,0,0,0,1.41,0l6.59-6.59a1,1,0,0,0,0-1.41L12.71,4.7A1,1,0,1,0,11.3,6.11L16.17,11H5a1,1,0,0,0,0,2Z",
    transform: "translate(0 0)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSide);
export default __webpack_public_path__ + "static/media/open_side.25d02695a0a2615f6141c06cbaeaf293.svg";
export { ForwardRef as ReactComponent };